import { useCallback, useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAnswerTypes = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchAnswerTypes = useCallback(async () => {
    startLoading();
    const response = await apiGet("/answer_types", "Error al obtener tipos de respuesta");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchAnswerTypes();
  }, [fetchAnswerTypes]);

  return { data, error, loading, refetch: fetchAnswerTypes };
};

export default useFetchAnswerTypes;
